module.exports = __webpack_public_path__ + "img/ic_my_loc.f7c8495c.svg";